import i18n from "@/i18n/index.js";

const columns = [
    {
        name: "img",
        field: row => row.coverMedia.url,
        label: "",
        sortable: false,
        align: "left"
    },
    {
        name: "name",
        label: i18n.t("admin.mktApps.name"),
        field: "name",
        sortable: true,
        align: "left"
    },
    {
        name: "button",
        label: "",
        field: "",
        sortable: false,
        align: "right"
    }
];

export default columns;
